import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@shop_allgaeu-brennerei_de/app.config';
import { AppComponent } from '@shop_allgaeu-brennerei_de/app.component';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
